import { render, staticRenderFns } from "./document-versions.vue?vue&type=template&id=55df0d95&scoped=true&"
import script from "./document-versions.vue?vue&type=script&lang=js&"
export * from "./document-versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df0d95",
  null
  
)

export default component.exports